import { render, staticRenderFns } from "./OptInError.vue?vue&type=template&id=bcd16562&scoped=true"
import script from "./OptInError.vue?vue&type=script&lang=js"
export * from "./OptInError.vue?vue&type=script&lang=js"
import style0 from "./OptInError.vue?vue&type=style&index=0&id=bcd16562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd16562",
  null
  
)

export default component.exports